module.exports = __webpack_public_path__ + "static/img/glove_flanelle.73ce8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_flanelle.png
// module id = cBji
// module chunks = 0